/* eslint-disable react-hooks/exhaustive-deps */
import { RadioGroupProps } from "@mui/material";
import { useEffect, useState } from "react";
import { Radio, RadioGroup } from "src/components";
import { IParametersKeyValue } from "src/store/Slices/Base/ParametersSlice";
import { getParametrePartsFind } from "src/utils/ParametreHelper";
import GnlParametreProps from "./gnl.parametre.props";
import { translate } from "src/i18n/tHelper";
interface GnlParametreRadioProps extends GnlParametreProps, RadioGroupProps {
    label?: string;
    error?: boolean;
    labelPlacement?: 'end' | 'start' | 'top' | 'bottom';
    disabledValues?: Array<number>;
    hepsiDahil?: boolean;
    filterCode?: Array<number>;
}
const translatePath = "parts|parametre";
const GnlParametreRadioGroup = (props: GnlParametreRadioProps): JSX.Element => {
    const [options, setOptions] = useState<Array<IParametersKeyValue>>(new Array<IParametersKeyValue>());
    const { parametreType, labelPlacement, error, helperText, value, ...rest } = props;

    useEffect(() => {
        const parameterState = getParametrePartsFind(props.sortById, props.parametreType, props.pasifDahil);
        var data: Array<IParametersKeyValue> = new Array<IParametersKeyValue>();
        if (props.hepsiDahil)
            data.push({ id: 0, key: 0, value: translate(translatePath, "Hepsi"), siraNo: 0, grupId: props.parametreType, aktif: "E", alan01: "", trValue: translate(translatePath, "Hepsi") });
        data = data?.concat(parameterState.map(p => ({...p, trValue: translate(translatePath, p.value) })));
        if (props.filterCode?.length > 0)
            data = data.filter(f => props.filterCode.includes(f.key));
        setOptions(data);
    }, []);

    return (
        <RadioGroup
            {...rest}
            id={"formLabel" + rest.id}
            label={rest.label ? rest.label : ""}
            sx={{ paddingLeft: props.label ? 2 : 0 }}
            error={Boolean(error)}
            helperText={helperText}
            typeof="number"
            value={value}
        >
            {options && options.map((v, i) => {
                return (
                    <Radio
                        disabled={rest.disabledValues?.includes(v.key)}
                        key={rest.name + i}
                        value={v.key}
                        label={v.trValue || v.value}
                    />
                );
            })}
        </RadioGroup>
    );
};
export default GnlParametreRadioGroup;